import { API } from "aws-amplify";
import { USERS as usersDao } from "@/api/UserManagementDao";

export class BillingsDao {

    private readonly API_NAME = "Viewpoint360API";

    async initiateCheckout(successUrl: string, cancelUrl: string, planIds: string[], coupon: string) {
        let currentUser = await usersDao.getCurrentUser();
        let req = {
            body: {
                successUrl: successUrl,
                cancelUrl: cancelUrl,
                planIds: planIds,
                coupon: coupon
            }
        }
        return await API.post(this.API_NAME, `/billing/${currentUser.userId}/checkout/session`, req);
    }

    async getCoupon(couponId: string) {
        return await API.get(this.API_NAME, `/billing/coupon/${couponId}`, {});
    }

    async getMembershipPlans() {
        let plans = await API.get(this.API_NAME, '/billing/membership/plans', {});
        return plans;
    }

    //Creates a product in stripe with id equal to decisionId
    // If product with decisionId exists then
    async createProduct(name: string, price: number, decisionId: string) {
        if (price === null) {
            return {};
        }
        price = price * 100;
        let req = {
            body: {
                name: name,
                price: price,
                decisionId: decisionId
            }
        }
        return await API.post(this.API_NAME, '/billing/products/create', req);
    }

    async unsubscribeToProduct(decisionId: string) {
        let currentUser = await usersDao.getCurrentUser();
        let req = {
            body: {
                decisionId: decisionId,
                billingId: currentUser.billingId
            }
        }
        return await API.post(this.API_NAME, '/billing/products/cancel', req);
    }

}

export const BILLINGS = new BillingsDao();